export function toggleReply(controller, event, controllerName) {
  const button = event.currentTarget;
  const commentId = button.dataset.commentId;
  const commentItem = button.closest(".comment-item");
  const replyFormContainer = commentItem.querySelector(
    ".reply-form-container",
  );

  if (
    controller.currentReplyForm &&
    controller.currentReplyForm !== replyFormContainer
  ) {
    controller.currentReplyForm.classList.add("d-none");
    controller.currentReplyForm.innerHTML = "";
  }

  if (replyFormContainer.classList.contains("d-none")) {
    replyFormContainer.innerHTML = getReplyFormHTML(commentId, controllerName);
    replyFormContainer.classList.remove("d-none");
    controller.currentReplyForm = replyFormContainer;
  } else {
    replyFormContainer.classList.add("d-none");
    replyFormContainer.innerHTML = "";
    controller.currentReplyForm = null;
  }
}

function getReplyFormHTML(parentId, controllerName) {
  return `
    <div class="reply-form mt-2">
      <form data-action="submit->${controllerName}#submitReply" data-parent-id="${parentId}">
        <textarea class="form-control comment-textarea" placeholder="Write a reply..." rows="2"></textarea>
        <div class="mt-2 d-flex gap-2">
          <button type="submit" class="btn btn-primary btn-sm"><i class="bi bi-reply me-1"></i>Reply</button>
          <button type="button" class="btn btn-secondary btn-sm" data-action="click->${controllerName}#cancelReply"><i class="bi bi-x-lg me-1"></i>Cancel</button>
        </div>
      </form>
    </div>
  `;
}

export function cancelReply(controller, event) {
  event.preventDefault();
  if (controller.currentReplyForm) {
    controller.currentReplyForm.classList.add("d-none");
    controller.currentReplyForm.innerHTML = "";
    controller.currentReplyForm = null;
  }
}

export function submitComment(url, fieldName, textValue) {
  const csrfToken = document.querySelector("[name='csrf-token']").content;

  return fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-CSRF-Token": csrfToken,
    },
    body: JSON.stringify({ [fieldName]: textValue }),
  }).then((response) => {
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    return response.json();
  });
}

export function submitReplyComment(url, fieldName, textValue, parentId) {
  const csrfToken = document.querySelector("[name='csrf-token']").content;

  return fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-CSRF-Token": csrfToken,
    },
    body: JSON.stringify({ [fieldName]: textValue, parent_id: parentId }),
  }).then((response) => {
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    return response.json();
  });
}
